import React from 'react';
import PropTypes from 'prop-types';
import useFetchRequiredPatientFields from 'App/hooks/useFetchRequiredPatientFields';
import { camelCase } from 'lodash';
import RequiredAsterisk from 'Shared/form/RequiredAsterisk';
import styled from '@emotion/styled';

const propTypes = {
    label: PropTypes.string.isRequired,
    fieldName: PropTypes.string.isRequired,
};

const LabelStyle = styled('span')`
    font-weight: bold;
`;

const RequiredTableHeaderLabel = ({ label, fieldName }) => {
    const { data: requiredFields = {} } = useFetchRequiredPatientFields();
    const isRequired = !!Object.values(requiredFields).find((field) => camelCase(field.field) === fieldName);

    if (!isRequired) {
        return label;
    }

    return (
        <LabelStyle>
            {label}
            <RequiredAsterisk />
        </LabelStyle>
    );
};

RequiredTableHeaderLabel.propTypes = propTypes;

export default RequiredTableHeaderLabel;
